import React, { useState, useContext } from "react";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiCloseCircleLine } from "react-icons/ri";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import ButtonUI from "../material-ui/ButtonUI";
import changeDocumentRequestSettingsStatus from "../../api/changeDocumentRequestSettingsStatus";
import { AuthContext } from "../../context/Auth/AuthContext";

/*** Component for updating Document Request Status ***/
const StatusPopup = ({
  setDocumentRequestSettingsAddedToTrue,
  tableValues,
}) => {
  const [open, setOpen] = useState(false);
  const { token, userID } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeStatusFormSubmit = async () => {
    const changeStatusFormResponse = await changeDocumentRequestSettingsStatus({
      token: token,
      user_id: userID,
      document_request_setting_id: tableValues.document_request_setting_id,
      status:
        tableValues.status.toLowerCase() === "active" ? "inactive" : "active",
    });

    if (changeStatusFormResponse?.code === 200) {
      setDocumentRequestSettingsAddedToTrue();
      setOpen(false);
      showSuccess("Document Request Status is successfully changed");
    } else {
      showError("Error while updating Document Request Status");
    }
  };

  return (
    <div className="dialog-modal">
      <div
        role="button"
        tabIndex={0}
        aria-label="Change Status"
        title="Change Status"
        onClick={handleClickOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClickOpen();
          }
        }}
        style={{
          color:
            tableValues.status.toLowerCase() === "inactive"
              ? "#e0a800"
              : "#28a745",
          backgroundColor:
            tableValues.status.toLowerCase() === "inactive"
              ? "rgba(255, 193, 7, 0.15)"
              : "rgba(40, 167, 69, 0.12)",
          borderColor:
            tableValues.status.toLowerCase() === "inactive"
              ? "rgba(255, 193, 7, 0.4)"
              : "rgba(40, 167, 69, 0.35)",
        }}
        className="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-lg border"
      >
        {tableValues.status.toLowerCase() === "inactive" ? (
          <RiCloseCircleLine style={{ fontSize: 18 }} />
        ) : (
          <HiOutlineCheckCircle style={{ fontSize: 18 }} />
        )}
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            {tableValues.status.toLowerCase() === "inactive" ? (
              <HiOutlineCheckCircle />
            ) : (
              <RiCloseCircleLine />
            )}
          </div>
          <div className="popup-header-title">
            Change Document Request Status
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to change Document Request status ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{
              margin: "15px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onChangeStatusFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default StatusPopup;
